




















import {Component, Vue} from "vue-property-decorator";

import {cartService} from '../services/cart-service';
import {apiService} from '../services/api-service';
import MainButton from '@/components/MainButton.vue';


@Component({
  components: {MainButton}
})
export default class OrderSuccess extends Vue {
  created() {
    let paymentID = this.$route.query.paymentId;
    let payerID = this.$route.query.PayerID;
    apiService.executeOrder(paymentID, payerID)
      .then(() => {
        cartService.clear();
        setTimeout(() => this.$router.push('/'), 5000);

      });
  }
}
